import { useWeb3React } from '@web3-react/core'
import { SUPPORTED_V3POOL_CHAIN_IDS } from 'constants/chains'

export function useNetworkSupportsV3() {
  const { chainId } = useWeb3React()
  return chainId && SUPPORTED_V3POOL_CHAIN_IDS.includes(chainId)
}
